import { render, staticRenderFns } from "./ProgressDialog.vue?vue&type=template&id=4e589c88&"
import script from "./ProgressDialog.vue?vue&type=script&lang=js&"
export * from "./ProgressDialog.vue?vue&type=script&lang=js&"
import style0 from "./ProgressDialog.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QDialog,QLinearProgress,QBadge});
